// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__188QZ","aside":"Footer_aside__3n9zm","row":"Footer_row__16dLG","title":"Footer_title__2-0u5","p":"Footer_p__1p26G","ticker":"Footer_ticker__W1vtg"};